const EChatStreamEventType = Object.freeze({
    Start: 0,
    Delta: 1,
    Complete: 2,
    Error: 3
});

export default EChatStreamEventType;